import { render, staticRenderFns } from "./FormOrganization.vue?vue&type=template&id=380fa048&scoped=true&"
import script from "./FormOrganization.vue?vue&type=script&lang=js&"
export * from "./FormOrganization.vue?vue&type=script&lang=js&"
import style0 from "./FormOrganization.vue?vue&type=style&index=0&id=380fa048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380fa048",
  null
  
)

export default component.exports